import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
h1,h2,h3,h4,h5 {
  margin-bottom: 4px;
  padding: 0;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

  body {
    font-family: Roboto;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .markdown-content {
    line-height: 23px !important;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #757575 transparent;
  }

  .markdown-content > div {
    width: 100%;
    overflow-x: auto;
  }

  .markdown-content ol, ul {
    list-style-position: inside;
    padding-left: 10px;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  .markdown-content li + li {
    margin-top: 4px;
  }

  .markdown-content li p {
    display: inline;
  }

  .markdown-content thead {
    color: black;
    font-weight: 600;
    text-transform: uppercase;
  }

  .markdown-content th {
    background: #FAFAFA;
    letter-spacing: 0.15px;
  }

  .markdown-content th > strong {
    font-weight: 600 !important;
  }

  table th:nth-child(1){
    border-radius: 8px 0px 0px 0px;
  }

  table th:nth-last-child(1){
      border-radius: 0px 8px 0px 0px;
  }

  .markdown-content tbody {
    color: #2E2E2E;
    font-size: 14px;
  }

  .markdown-content th, td {
    text-align: left;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 10px;
    padding-right: 10px;
    border-bottom: 1px solid #E0E2E2;
  }

  table tr:nth-last-child(1) td{
      border: none;
  }
`

export default GlobalStyles
